export const getters = {
  calculateDriveIdOrMyDrive(state) {
    return driveId => {
      return driveId ? driveId : state.myDriveRootIdString;
    };
  },

  calculateRootOrDriveId() {
    return driveId => {
      return driveId ? driveId : this.myDriveRootId;
    };
  },

  myDriveRootId(state) {
    return state.myDriveRootIdString;
  },

  driveType(state) {
    return driveId => {
      const realDriveId = this.calculateRootOrDriveId(driveId);
      return state.driveTypeMap[realDriveId];
    };
  }
};
